import './Home.css';

import NoiseEffect from '../components/NoiseEffect';
import Hero from '../components/Hero';
import Movie from '../components/Movie';
import Ready from '../components/Ready';
import Vision from '../components/Vision';
import Zoku from '../components/Zoku';
import Utility from '../components/Utility';
import Member from '../components/Member';
import FollowUs from '../components/FollowUs';
import Footer from '../components/Footer';

export default function Home() {

    return (
        <div className="Home">
            <NoiseEffect />
            <Hero />
            <Movie />
            <Ready />
            <Vision />
            <Zoku />
            <Utility />
            <Member />
            <FollowUs />
            <Footer />
        </div>
    );
}